import React from 'react';
import { modelClass } from '/imports/api/cardLists';
import { ModelListPage } from '/imports/ui/ModelListPage';

export const CardListsPage = () => (
  <ModelListPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    columns={[
      { field: 'name', label: 'Name' },
      { field: 'description', label: 'Description' },
      {
        field: 'query', label: 'Query',
        render: (l) => (
          <span className="font-mono text-caption text-fg-3">
            {JSON.stringify((l as any).query ?? {}).slice(0, 80)}
          </span>
        ),
      },
    ]}
  />
);
